<script setup lang="ts">
import {Model} from "@/app/Model";
import PaginazioneResponsabilitaLista from "@/components/atomics/PaginazioneAdminResponsabilitaListaResponsabilita.vue";
import FiltriResponsabilitaLista from "@/components/atomics/FiltriAdminResponsabilitaListaResponsabilita.vue";
import ModalAdminResponsabilitaItem from "@/components/atomics/ModalAdminResponsabilitaItem.vue";
import {ref} from "vue";
import {CommsResponsabilita, type IEsito} from "@/app/CommsResponsabilita";
import type {KeyValoreStr} from "@/app/data/DataTypes";
import { Modal } from 'bootstrap';
import {ItemResponsabilita} from "@/app/data/ResponsabilitaAdmin";

let model: Model = Model.getReactiveInstance();

//components
const paginazione_component = ref(null);
const updatePaginazione = (): void => {
  try {
    //@ts-ignore
    paginazione_component.value.updatePaginazione();
  } catch (e) {
    //console.log("%%%%", e)
  }
}
function callQueryPaginazione(): void {
  callQuery(true);
}
function callQueryFiltri(): void {
  callQuery(false);
}
function updateComponents(): void {
  //PAGINAZIONE
  updatePaginazione();
}
window.addEventListener(
    "listAllRefresh",
    (event) => {
      updateComponents();
    }
);
//@ts-ignore
window.updateComponentsAdminResponsabilita = updateComponents;

//business
function callQuery(soloPaginazione: boolean = false): void {
  CommsResponsabilita.getInstance().responsabilitaAdmin.chiamataResponsabilitaList((e: IEsito) => {
    updateComponents();
  }, soloPaginazione);
}
function editItem(id_doc_master: number = -1): void {
  if (id_doc_master > 0) {
    let canOpen: boolean = false;
    model.res_admin.itemResponsabilita = new ItemResponsabilita();
    let findResponsabilita: ItemResponsabilita = model.res_admin.listaResponsabilita.find( (x)=> x.id_doc_master == id_doc_master) as ItemResponsabilita;

    if (findResponsabilita != undefined && findResponsabilita != null) {
      model.res_admin.itemResponsabilita = findResponsabilita;
      canOpen = true;
    }
    //console.log("%%%%%%%%%%%%%%%%%%% id_doc_master", id_doc_master, "canOpen", canOpen, "findResponsabilita", findResponsabilita, "model.res_admin.itemResponsabilita", model.res_admin.itemResponsabilita)
    if (canOpen) {
      const modal = Modal.getOrCreateInstance('#ModalAdminResponsabilitaItem');
      modal.show();
    }
  }
}

//render
function renderCitta(id_localita: string): string {
  let out = id_localita;
  let findCitta: KeyValoreStr | undefined = model.res_lista_citta.find((x: KeyValoreStr): boolean => { return x.id_localita == id_localita });
  if (findCitta) out = findCitta.citta;
  return out;
}
</script>

<template>
  <ModalAdminResponsabilitaItem></ModalAdminResponsabilitaItem>
  <FiltriResponsabilitaLista @recalc="callQueryFiltri()"></FiltriResponsabilitaLista>
  <div class="table-responsive small table-documenti" v-if="model.res_admin.listaResponsabilita && model.res_admin.listaResponsabilita.length && model.res_admin.listaResponsabilita.length > 0">
    <table class="table table-striped table-sm table-admin">
      <thead>
        <tr>
          <th>Id Doc Master</th>
          <th>Ogg. Giudizio</th>
          <th>Tipo Proced.</th>
          <th>Rif. Norm.</th>
          <th>Addebito</th>
          <th>Motivi Addeb.</th>
          <th>Reg. Mant.</th>
          <th>Reg. Aff.</th>
          <th>Reg. Coll.</th>
          <th>Data </th>
          <th>Località</th>
          <th>Durata Proc.</th>
          <th>Giudice</th>
          <th>Data Elaborazione</th>
          <th>Modifica Manuale</th>
          <th scope="col"> </th>
        </tr>
      </thead>
      <tbody>
      <template v-for="(item, index) in model.res_admin.listaResponsabilita">
        <tr :id="'docRiga-responsabilita-admin-'+index">
          <td>{{ item.id_doc_master }}</td>
          <td>{{ item.oggetto_di_giudizio }}</td>
          <td>{{ item.tipologia_procedimento }}</td>
          <td>{{ item.riferimento_normativo?.join(', ') }}</td>
          <td>{{ item.addebito?.toString() }}</td>
          <td>{{ item.motivi_addebito_separazione?.join(', ') }}</td>
          <td>{{ item.regime_mantenimento }}</td>
          <td>{{ item.regime_affidamento }}</td>
          <td>{{ item.regime_collocamento }}</td>
          <td>{{ (item.data!= null? (new Date(item.data as string)).toLocaleDateString() : "") }}</td>
          <td>{{ renderCitta(item.id_localita as string) }}</td>
          <td class="text-center">{{ item.durata_procedimento }}</td>
          <td>{{ item.giudice?.join(', ') }}</td>
          <td>{{ (item.data_elaborazione!= null? (new Date(item.data_elaborazione as string)).toLocaleDateString() : "") }}</td>
          <td>{{ item.modifica_manuale }}</td>
          <td class="text-right">
            <a href="javascript:void(0)" :title="'Modifica ' + item.id_doc_master" @click="editItem(item.id_doc_master)">
              <i class="bi bi-pencil-square"></i>
            </a>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>

  <div class="row" v-if="model.res_admin.listaResponsabilita && model.res_admin.listaResponsabilita.length && model.res_admin.listaResponsabilita.length > 0">
    <div class="col-12 col-sm-6 paginazione-label">
      <b>{{ model.res_admin.paginazioneResponsabilita_tot }}</b> Elementi Totali |
      Pagina <b>{{ (model.res_admin.paginazioneResponsabilita_start + 1) }}</b> di
      <b>{{ (model.res_admin.paginazioneResponsabilita_pages + 1) }}</b>
    </div>
    <div class="col-12 col-sm-6">
      <PaginazioneResponsabilitaLista ref="paginazione_component" @recalc="callQueryPaginazione()"></PaginazioneResponsabilitaLista>
    </div>
  </div>
  <div class="row" v-else>
    <div class="col-12">
      Non sono presenti sentenze
    </div>
  </div>
</template>